module.exports = __webpack_public_path__ + "img/mercer-logo-white.b0ca85ab.png";